import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { authActions } from "../../store/auth";
import NotFound from "./404";
import UploadAssetsForm from "./UploadAssetsForm";

const UploadAssets = () => {

  const user_roles = useSelector((state) => state.auth.roles);
  const dispatch = useDispatch();

  useEffect(() => {
      dispatch(authActions.setLoaderStatus({ status: true }));
      document.title = `Upload Assets`;
      dispatch(authActions.setLoaderStatus({ status: false }));

      
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {user_roles.role_id === 1 ? (
        <NotFound />
      ) : (
        <section className="mid_wrap">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-4 pb-2">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item " aria-current="page">
                  <Link to="/uploadAssets">Upload Assets</Link>
                </li>
              </ol>
            </nav>
            <div className="row d-flex justify-content-center ">
              <div className="col-md-8 ">
                <div className="bx_a">
                  <UploadAssetsForm />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default UploadAssets;
